import api from './api';
import { RegisterRequest, LoginRequest, AuthResponse, User } from '../types';

export const authService = {
    async register(data: RegisterRequest): Promise<AuthResponse> {
        const response = await api.post<{ success: boolean; data: AuthResponse }>('/auth/register', data);
        return response.data.data;
    },

    async login(data: LoginRequest): Promise<AuthResponse> {
        const response = await api.post<{ success: boolean; data: AuthResponse }>('/auth/login', data);
        return response.data.data;
    },

    async googleLogin(credential: string): Promise<AuthResponse> {
        const response = await api.post<{ success: boolean; data: AuthResponse }>('/auth/google', { credential });
        return response.data.data;
    },

    async getCurrentUser(): Promise<User> {
        const response = await api.get<{ success: boolean; data: User }>('/auth/me');
        return response.data.data;
    },

    async logout(): Promise<void> {
        await api.post('/auth/logout');
    },
};
